module.exports = __webpack_public_path__ + "img/pedal-boats--icon--gray.762f5ed3.svg";